import { render, staticRenderFns } from "./DiscountDetails.vue?vue&type=template&id=43bb0f14&scoped=true&"
import script from "./DiscountDetails.vue?vue&type=script&lang=js&"
export * from "./DiscountDetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/form.css?vue&type=style&index=0&id=43bb0f14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb0f14",
  null
  
)

export default component.exports